import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';
import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';
import procurementDropdown from '@/redux/slice/procurementSlice/dropdownslice';
import procurementReducer from './slice/slice.procurement';
import salesReducer from './slice/slice.sales';
import authReducer from './slice/slice.auth';
import inventoryReducer from './slice/slice.inventory';
import secondaryOrderUnloadingReducer from './slice/slice.secondaryOrderUnloading';
import { thunkApis } from './thunk/reduxApis';
import screenRecordReducer from './slice/slice.ticketing';

const apiReducers = thunkApis.reduce<Record<string, any>>((pre, cur) => {
	return {
		...pre,
		[cur.reduxKey]: cur.reducer,
	};
}, {});

const combinedReducer = combineReducers({
	procurementdropdown: procurementDropdown,
	procurement: procurementReducer,
	sales: salesReducer,
	auth: authReducer,
	inventory: inventoryReducer,
	secondaryOrderUnloading: secondaryOrderUnloadingReducer,
	apis: combineReducers(apiReducers),
	screenRecord: screenRecordReducer,
});
export const rootReducer = (
	state: Parameters<typeof combinedReducer>[0],
	action: AnyAction,
) => {
	if (action.type === 'auth/logout') {
		localStorage.removeItem('user-data');
		state = undefined;
	}
	return combinedReducer(state, action);
};

const reduxStore = configureStore({
	reducer: rootReducer,
});

export type TypeAppDispatch = typeof reduxStore.dispatch;
export type AppRootState = ReturnType<typeof reduxStore.getState>;

export const useAppDispatch = () => useDispatch<TypeAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;

export default reduxStore;
